(function () {

    angular
        .module('smartertoolsApp')
        .controller('leasesController',
            [
                '$scope', '$q', '$timeout', 'leaseProviderService', 'partnerService', 'notificationFactory', 'authenticationService', leasesController
            ]);

    function leasesController($scope, $q, $timeout, leaseProviderService, partnerService, notify, authenticationService) {
        const vm = this;
        vm.mode = 'main';
        vm.leases = null;
        vm.leaseSearch = '';
        vm.currentPage = 1;
        vm.filteredLeases = null;
        vm.itemsPerPage = 10;
        vm.partnerInfo = null;
        vm.selectedLease = null;
        vm.totalFilteredItems = 0;
        vm.isProcessing = false;
        vm.newLease = {};
        vm.upgradeLease = {};
        vm.emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        vm.agreement = { subject: '', body: '', type: '', isAccepted: false };

        // Functions
        vm.doLeaseStop = doLeaseStop;
        vm.doLeaseUpgrade = doLeaseUpgrade;
        vm.doStartLease = doStartLease;
        vm.filter = filter;
        vm.getCsvData = getCsvData;
        vm.getCsvHeader = getCsvHeader;
        vm.recalcStartLeaseItems = recalcStartLeaseItems;
        vm.recalcUpgradeLeaseItems = recalcUpgradeLeaseItems;
        vm.refreshData = refreshData;
        vm.selectLease = selectLease;
        vm.showLeaseStart = showLeaseStart;
        vm.showLeaseStop = showLeaseStop;
        vm.showLeaseUpgrade = showLeaseUpgrade;
        vm.showTermsAgreementOverlay = showTermsAgreementOverlay;
        vm.sort = sort;

        activate();

        // -----------------------------------------------

        function activate() {
            vm.refreshData();
        }

        function filter() {
            $timeout(() => { vm.totalFilteredItems = vm.filteredLeases ? vm.filteredLeases.length : 0; }, 10);
        }

        function sort(keyName) {
            vm.reverse = vm.sortKey !== keyName || !vm.reverse;
            vm.sortKey = keyName;
        }

        function getCsvHeader() {
            return ['Lease ID', 'Start Date', 'Email Address', 'Product', 'Addons', 'Machine Name', 'Last Activated IP', 'Monthly Cost to You', 'Customer Name', 'Custom ID', 'Custom Data'];
        }

        function getCsvData() {
            const items = [];
            for (let i = 0; i < vm.leases.length; i++) {
                const item = vm.leases[i];
                let addonNames = '';
                for (let j = 0; j < item.Addons.length; j++) {
                    const a = item.Addons[j];
                    if (addonNames != '')
                        addonNames += ', ';
                    addonNames += a.MasterProductName === 'Exchange ActiveSync' ? a.Product : a.MasterProductName;
                }
                items.push({
                    leaseid: item.LeaseId,
                    start: moment(item.StartDate).format(),
                    email: item.Email,
                    product: item.Product,
                    addons: addonNames,
                    machineName: item.MachineName,
                    lastActivatedIpAddress: item.LastActivatedIpAddress,
                    monthlyCost: '$' + item.TotalCost,
                    customerName: item.CustomerName,
                    customId: item.CustomId,
                    customData: item.CustomData,

                });
            }
            return items;
        }


        function selectLease(item) {
            vm.selectedLeaseMode = 'start';
            vm.selectedLease = item;
            vm.selectedLeaseHistory = null;
            vm.isProcessing = false;
            vm.resendDone = false;
            vm.selectedLeaseHistory = [];
            bootstrap.Tab.getOrCreateInstance(document.getElementById('lease-details-tab')).show();
            bootstrap.Modal.getOrCreateInstance(document.getElementById('lease-view-modal')).show();
            leaseProviderService.getLeaseHistory(vm.selectedLease.LeaseId)
                .then((history) => { vm.selectedLeaseHistory = history; });
        }

        function showLeaseStart() {
            vm.availableProductInfo = null;
            vm.newLease.done = false;
            vm.newLease.isSending = false;
            leaseProviderService.getProductsAvailable()
                .then((categories) => {
                    vm.availableProductInfo = categories;
                    vm.newLease = { Msrp: 0, TotalCost: 0, sendEmailToCustomer: true };
                    vm.leaseStart.$setPristine();
                    vm.leaseStart.$setUntouched();
                    bootstrap.Modal.getOrCreateInstance(document.getElementById('lease-start-modal')).show();
                    $timeout(() => RecalculateAllFloatLabelControls());
                });
        }

        function showLeaseStop() {
            vm.selectedLeaseMode = 'stop-confirmation';
        }

        function showLeaseUpgrade() {
            vm.availableProductInfo = null;
            leaseProviderService.getProductsAvailable()
                .then((categories) => {

                    vm.availableProductInfo = categories;
                    vm.upgradeLease = { Msrp: 0, TotalCost: 0, sendEmailToCustomer: true, LeaseId: vm.selectedLease.LeaseId, Addon: [] };

                    // Select Product and addons
                    for (let i = 0; i < categories.length; i++) {
                        const cat = categories[i];
                        for (let j = 0; j < cat.Products.length; j++) {
                            const prod = cat.Products[j];
                            if (prod.ProductId == vm.selectedLease.ProductId) {
                                vm.upgradeLease.Category = cat;
                                vm.upgradeLease.Product = prod;
                                if (prod.AddonsByCategory) {
                                    for (let k = 0; k < prod.AddonsByCategory.length; k++) {

                                        const addonCat = prod.AddonsByCategory[k];
                                        for (let ap = 0; ap < addonCat.Addons.length; ap++) {
                                            const addonInfo = addonCat.Addons[ap];
                                            for (let s = 0; s < vm.selectedLease.Addons.length; s++) {
                                                const selectedAddon = vm.selectedLease.Addons[s];
                                                if (addonInfo.ProductId == selectedAddon.ProductId)
                                                    vm.upgradeLease.Addon[k] = selectedAddon.ProductId;
                                            }
                                        }

                                    }
                                }
                            }
                        }
                    }

                    vm.recalcUpgradeLeaseItems();
                    vm.leaseView.$setPristine();
                    vm.leaseView.$setUntouched();
                    vm.selectedLeaseMode = 'upgrade-configure';
                    $timeout(() => RecalculateAllFloatLabelControls());
                });
        }

        function doStartLease() {
            if (vm.leaseStart.$invalid)
                return;
            vm.newLease.isSending = true;
            const addonIds = [];
            for (let addonCategoryKey in vm.newLease.Addon) {
                if (!vm.newLease.Addon.hasOwnProperty(addonCategoryKey)) continue;
                const addonId = vm.newLease.Addon[addonCategoryKey];
                if (!addonId)
                    continue;
                addonIds.push(addonId);
            }
            leaseProviderService.startLease(
                vm.newLease.Email,
                vm.newLease.CustomerName,
                vm.newLease.CustomData,
                vm.newLease.sendEmailToCustomer,
                vm.newLease.Product.ProductId,
                addonIds)
                .then((result) => {
                    leaseProviderService.clearLeaseCache();
                    vm.refreshData();
                    vm.newLease.result = result;
                    vm.newLease.isSending = false;
                    vm.newLease.done = true;
                })
                .catch((err) => {
                    vm.newLease.isSending = false;
                    // notify here
                });
        }

        function doLeaseUpgrade() {
            vm.isProcessing = true;
            const addonIds = [];
            for (let addonCategoryKey in vm.upgradeLease.Addon) {
                if (!vm.upgradeLease.Addon.hasOwnProperty(addonCategoryKey)) continue;
                const addonId = vm.upgradeLease.Addon[addonCategoryKey];
                if (!addonId)
                    continue;
                addonIds.push(addonId);
            }
            leaseProviderService.modifyLease(vm.upgradeLease.LeaseId, vm.upgradeLease.Product.ProductId, addonIds, vm.upgradeLease.sendEmailToCustomer)
                .then((result) => {
                    leaseProviderService.clearLeaseCache();
                    vm.refreshData();
                    vm.isProcessing = false;
                    vm.selectedLeaseMode = 'upgrade-result';
                })
                .catch((err) => {
                    vm.isProcessing = false;
                    notify.error(`There was a problem saving your changes.  ${err.statusText}`);
                });
        }

        function doLeaseStop() {
            vm.isProcessing = true;
            leaseProviderService.stopLease(vm.selectedLease.LeaseId)
                .then((result) => {
                    leaseProviderService.clearLeaseCache();
                    vm.refreshData();
                    vm.isProcessing = false;
                    vm.selectedLeaseMode = 'stop-result';
                })
                .catch((err) => {
                    vm.isProcessing = false;
                    //TODO: notify
                });
        }

        function recalcStartLeaseItems() {
            recalcLeaseItems(vm.newLease);
        }

        function recalcUpgradeLeaseItems() {
            recalcLeaseItems(vm.upgradeLease);
        }

        function recalcLeaseItems(lease) {
            let msrp = 0;
            let cost = 0;
            if (lease.Product) {
                msrp += lease.Product.Msrp;
                cost += lease.Product.PartnerCost;
                const keysToRemove = [];
                if (lease.Addon && lease.Product.AddonsByCategory) {
                    for (let addonCategoryKey in lease.Addon) {
                        if (!lease.Addon.hasOwnProperty(addonCategoryKey)) continue;
                        const addonId = lease.Addon[addonCategoryKey];
                        if (!addonId)
                            continue;
                        const cat = lease.Product.AddonsByCategory[addonCategoryKey];
                        if (cat && cat.Addons) {
                            for (let k = 0; k < cat.Addons.length; k++) {
                                const addon = cat.Addons[k];
                                if (addon.ProductId == addonId) {
                                    msrp += addon.Msrp;
                                    cost += addon.PartnerCost;
                                    break;
                                }
                            }
                        } else {
                            keysToRemove.push(addonCategoryKey);
                        }
                    }
                }
                for (let i = 0; i < keysToRemove.length; i++) {
                    lease.Addon[keysToRemove[i]] = undefined;
                }
            }
            lease.Msrp = msrp;
            lease.TotalCost = cost;
            $timeout(() => RecalculateAllFloatLabelControls());
        }

        function refreshData() {
            $scope.accountCtrl.isLoading += 2;
            $q.all(
                [
                    leaseProviderService.getActiveLeases(),
                    partnerService.getPartnershipDetails()
                ])
                .then((values) => {
                    $scope.accountCtrl.isLoading -= 2;
                    vm.leases = values[0];
                    vm.partnerInfo = values[1];
                    vm.filter();
                    authenticationService.showTermsCondition((data) => {
                        const showAgreement = data;
                        if (showAgreement == true) {
                            ShowTermsAgreementOverlay();
                        }
                    });
                })
                .catch((e) => {
                    if (e.status == 403) {
                        window.location.href = '/company/partners';
                        return;
                    }
                    $scope.accountCtrl.isLoading -= 2;
                    notify.error('There was a problem loading this information.  Please try again later.');
                });
        }

        function showTermsAgreementOverlay() {
            authenticationService.getAgreement((data) => {
                vm.agreement.body = data.Body;
                vm.agreement.subject = data.Subject;
                vm.agreement.type = data.Type;
                const modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('partner-agreement-resource'));
                modal.show();
            });
        }
    }

})();